import styled from "styled-components";

type ContainerType = {
    background: string;
    border: string;
};

type TextType = {
    color: string;
};

type IconCircleType = {
    background: string;
};

export const Banner = styled.div<ContainerType>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: ${(props) => props.background};
  border: 1px solid ${(props) => props.border};
  border-radius: 10px;
`;

export const IconCircle = styled.div<IconCircleType>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 50%;
  background: ${(props) => props.background};
`;

export const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const BannerTitle = styled.span<TextType>`
  font-size: 15px;
  font-weight: 700;
  color: ${(props) => props.color};
  line-height: 1.3;
`;

export const BannerText = styled.span<TextType>`
  font-size: 13px;
  font-weight: 400;
  color: ${(props) => props.color};
  line-height: 1.5;
`;
